module.exports = __webpack_public_path__ + "img/force4.db655e40.png";